"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash.merge"));

var _v = _interopRequireDefault(require("uuid/v1"));

var _ingest = _interopRequireDefault(require("@ccx-public/ingest"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SINGLETON_CONTROLLER_MAP = {
  // no op for when no controller is present.
  fireEvent: function fireEvent() {
    return Promise.resolve();
  },
  flush: function flush() {
    return Promise.resolve();
  }
};
/**
 * IngestController class
 */

var IngestController =
/*#__PURE__*/
function () {
  /**
   * Constructor for IngestController
   * @param {object} props - base data object based on SDM
   * @returns {undefined}
   */
  function IngestController(props) {
    _classCallCheck(this, IngestController);

    this.configure(props);
    this.offlineQueue = [];
    this.fireEvent = this.fireEvent.bind(this);
    this.fireQueuedEvents = this.fireQueuedEvents.bind(this);
    this._sessionGuid = (0, _v["default"])();
    window.addEventListener('online', this.fireQueuedEvents);
  }
  /**
   * configures the controller. Used for instantiation or when values changes.
   * @param {object} props - base data object based on SDM
   * @returns {undefined}
   */


  _createClass(IngestController, [{
    key: "configure",
    value: function configure(props) {
      var token = props.token;
      var onLog = props.onLog;

      if (!props.apiInstance) {
        var dependencies = {
          getAccessToken: function getAccessToken(cb) {
            cb(null, token);
          },
          log: function log(message) {
            onLog && onLog(message);
          }
        };
        var options = {
          ENVIRONMENT: props.env,
          ALLOW_NO_TOKEN: props.allowNoToken,
          ANALYTICS_API_KEY: props.apiKey,
          ANALYTICS_PROJECT: props.project,
          ANALYTICS_X_PRODUCT: props.product,
          ANALYTICS_X_PRODUCT_LOCATION: props.productLocation,
          ANALYTICS_MAX_QUEUED_EVENTS: props.maxQueuedEvents,
          ANALYTICS_DEBOUNCE: props.debounce,
          ANALYTICS_USER_REGION: props.userRegion,
          ANALYTICS_INGEST_TYPE: props.ingestType,
          TIMESTAMP_PROPERTY_NAME: props.timestampPropertyName
        };
        var apiInstance = new _ingest["default"](dependencies, options);
        apiInstance.enable(true);
        this._ingestApi = apiInstance;
      } else {
        this._ingestApi = props.apiInstance;
      }

      this.updateData(props.data);
      this.project = props.project;
    }
    /**
     * Function to update data
     * @param {object} data - data to update the base data object
     * @returns {undefined}
     */

  }, {
    key: "updateData",
    value: function updateData(data) {
      this._baseData = data;
    }
    /**
     * Private function to flatten an object
     * @param {object} nestedObj - object to be flattened
     * @param {object} flatObj - object is being flattened
     * @param {object} curPrefix - key prefix used for flattening
     * @returns {object} flattened object
     */

  }, {
    key: "_flattenObj",
    value: function _flattenObj(nestedObj, flatObj, curPrefix) {
      var _this = this;

      Object.keys(nestedObj).forEach(function (key) {
        var value = nestedObj[key];
        var newKey = curPrefix ? "".concat(curPrefix, ".").concat(key) : key;

        if (value && _typeof(value) === 'object' && !(value instanceof Date)) {
          _this._flattenObj(value, flatObj, newKey);
        } else {
          flatObj[newKey] = value;
        }
      });
      return flatObj;
    }
    /**
     * Flush events that were queued while offline.
     * @returns {undefined}
     */

  }, {
    key: "fireQueuedEvents",
    value: function fireQueuedEvents() {
      var _this2 = this;

      this.offlineQueue.forEach(function (_ref) {
        var augmentedData = _ref.augmentedData,
            fireImmediately = _ref.fireImmediately,
            options = _ref.options,
            mergeBaseData = _ref.mergeBaseData;

        _this2.fireEvent(augmentedData, fireImmediately, options, mergeBaseData);
      });
      this.offlineQueue = [];
    }
    /**
     * Function to fire an event to Ingest
     * @param {object} augmentedData - object to augment base data set for event
     * @param {boolean} fireImmediately - indication if we should immediately fire
     * @param {object} options - optional project override block (params outside payload)
     * @param {boolean} mergeBaseData - indication if we should merge augmentedData into current base data object
     * @returns {object} promise for event being fired
     */

  }, {
    key: "fireEvent",
    value: function fireEvent() {
      var _this3 = this;

      var augmentedData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var fireImmediately = arguments.length > 1 ? arguments[1] : undefined;
      var options = arguments.length > 2 ? arguments[2] : undefined;
      var mergeBaseData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      return new Promise(function (resolve, reject) {
        var result = {};

        if (mergeBaseData) {
          var _sdmJsonData$event$se, _sdmJsonData$event$gu, _sdmJsonData$event$of;

          var sdmJsonData = (0, _lodash["default"])({}, _this3._baseData) || {};

          if (!sdmJsonData.event) {
            sdmJsonData.event = {};
          }

          sdmJsonData.event.session_guid = (_sdmJsonData$event$se = sdmJsonData.event.session_guid) !== null && _sdmJsonData$event$se !== void 0 ? _sdmJsonData$event$se : _this3._sessionGuid;
          sdmJsonData.event.guid = (_sdmJsonData$event$gu = sdmJsonData.event.guid) !== null && _sdmJsonData$event$gu !== void 0 ? _sdmJsonData$event$gu : (0, _v["default"])();
          sdmJsonData.event.offline = (_sdmJsonData$event$of = sdmJsonData.event.offline) !== null && _sdmJsonData$event$of !== void 0 ? _sdmJsonData$event$of : (!navigator.onLine).toString();
          (0, _lodash["default"])(result, sdmJsonData, augmentedData);
        } else {
          result = augmentedData;
        }

        var flattenedBody = _this3._flattenObj(result, {});

        var cb = function cb(err) {
          if (!err) {
            resolve(flattenedBody);
          } else {
            reject(err);
          }
        };

        if (navigator.onLine) {
          _this3._ingestApi.postEvent(flattenedBody, !fireImmediately ? cb : undefined, options);

          if (fireImmediately) {
            _this3._ingestApi.flush(true, cb);
          }
        } else {
          resolve(flattenedBody);

          _this3.offlineQueue.push({
            augmentedData: result,
            fireImmediately: fireImmediately,
            options: options,
            mergeBaseData: false
          });
        }
      });
    }
    /**
     * Function to flush the event queue
     * @returns {object} promise for event being fired
     */

  }, {
    key: "flush",
    value: function flush() {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        var cb = function cb(err) {
          if (!err) {
            resolve();
          } else {
            reject(err);
          }
        };

        _this4._ingestApi.flush(true, cb);
      });
    }
    /**
     * Deletes the controller from the singleton map.
     * @returns {undefined}
     */

  }, {
    key: "delete",
    value: function _delete() {
      window.removeEventListener('online', this.fireQueuedEvents);
      this.offlineQueue = [];
      delete SINGLETON_CONTROLLER_MAP[this.project];
    }
  }]);

  return IngestController;
}();
/**
 * configures the controller. Used for instantiation or when values changes.
 * @param {object} props - base data object based on SDM
 * @returns {undefined}
 */


function IngestControllerSingleton(props) {
  var instance;

  if (SINGLETON_CONTROLLER_MAP[props.project]) {
    instance = SINGLETON_CONTROLLER_MAP[props.project];
    instance.configure(props);
  } else {
    instance = new IngestController(props);
    SINGLETON_CONTROLLER_MAP[props.project] = instance;
  }

  return instance;
}
/**
 * Function designed to allow direct access to the IngestController for a project
 * @param {String} project - project name for on instantiated IngestController
 * @returns {IngestController} - IngestController
 */


IngestControllerSingleton.getInstance = function getInstance(project) {
  return SINGLETON_CONTROLLER_MAP[project] || SINGLETON_CONTROLLER_MAP;
};

var _default = IngestControllerSingleton;
exports["default"] = _default;